import React, {Component} from 'react'
import { withApollo } from 'react-apollo'
import PropTypes from 'prop-types'
import { Tabs, Typography, Spin, Row, Col, Input, message, Table, Icon, Button, Popconfirm, Form, Select } from 'antd'
import FromInput from '../from/Input'
import SelectStatus from '../from/SelectStatus'
import moment from 'moment'
import { changeFormatdate } from '../../../utils/formatdate'

const { TabPane } = Tabs
const { Text, Title } = Typography
const { Option } = Select;

const newsDataProfile = '';

class FormHospital extends Component {
	state = {
		
	}

    handleSubmit = async (e) => {
        const { form, afterSubmit, client } = this.props
        const { telNo, otpToken, refCode } = this.state
        console.log(e)
		// await e.preventDefault()
		form.validateFields(async (err, values) => {
            afterSubmit()
		// 	if (!err) {
        //         try {
                    
        //             const { data, errors } = await client.mutate({
        //                 mutation: Mutations.changePhoneNumber,
        //                 variables: {
        //                     telNo,
        //                     otp:{
        //                         otpToken: otpToken,
        //                         refCode: refCode,
        //                         otpCode: values.otp
        //                     }
        //                 }
        //             })

        //             console.log(data)

        //             if(data){
        //                 message.success("ส่งเพื่อดำเนินการเรียบร้อย")
        //                 setTimeout(() => {
        //                     window.location.reload();
        //                 }, 600);
        //             }
        //         }catch (error) {
                    
        //         }
		// 	}
		})
	}

    cancel = () =>{
        window.location.href = '/hospital/search'
    }

	delectField = (id) =>{
		alert('test')
	}

	paginationChange = async e => {
        let offset = 0;
        if (e.current === 1) {
            offset = 0
        } else {
            offset = e.current - 1 + "0"
        }

        await this.setState({
            pageData: {
                offset: parseInt(offset),
                limit: 10
            }
        })

        // this.fetchListPost()
    }

	async componentDidMount(){
        console.log('sss',this.props)
		// await this.fetchProfile()
    }

	render() {
		const { listFamily, detailProfile } = this.props
        const { getFieldDecorator } = this.props.form

        console.log('detailProfile',detailProfile)
		return (
            <div className="card-container" id="page-profile">
                <div className="px-5 py-1 card-bg-green">
                    <Form >
                        <Row gutter={16} type="flex" justify="left" align="top" className="box-color-white" >
                            <Col xs={24} md={24} className="pt-2">
                                <strong className="color-red">
                                    ผลลัพธ์การค้นหา
                                </strong>
                            </Col>

                            <Col xs={ 24 } md={12} >
                                <FromInput value={detailProfile ? detailProfile.employeeCodes : ''} disabled={true} required={false} name={"code"} label="รหัสบุคลากร" mode={"text"} />
                            </Col>

                            <Col xs={ 24 } md={12} >
                                <FromInput value={detailProfile.name} disabled={true} required={false} name={"ชื่อบุคลากร"} label="ชื่อบุคลากร" mode={"text"} />
                            </Col>

                            <Col xs={ 24 } md={12} >
                                <FromInput value={detailProfile.divisionName} disabled={true} required={false} name={"ฝ่าย"} label="ฝ่าย" mode={"text"} />
                            </Col>

                            <Col xs={ 24 } md={12} >
                                <FromInput value={detailProfile.agencyName ? detailProfile.agencyName : '-'} disabled={true} required={false} name={"หน่วยงาน"} label="หน่วยงาน" mode={"text"} />
                            </Col>
                        </Row>

                        <Row gutter={16} type="flex" justify="left" align="top" className="box-color-white" >
                            <Col xs={24} md={24} className="pt-2 mb-3">
                                <strong className="color-red">
                                    ผู้มีสิทธิ์เบิกค่ารักษาพยาบาล
                                </strong>
                            </Col>
                            
                            {
                                listFamily.length !== 0 ? 
                                    listFamily.map((valuseLabel, keysLabel) =>{
                                        return  <>
                                                     <Col xs={24} md={24} className="mt-3">
                                                        <Text style={{ color:"#000" }}>
                                                            { valuseLabel.relationShipLabel }
                                                        </Text>
                                                    </Col>

                                                    <Col xs={ 24 } md={10} >
                                                        <FromInput value={valuseLabel.fullName} disabled={true} required={false} name={"fullName"} label="ชื่อ-นามสกุล" mode={"text"} />
                                                    </Col>

                                                    <Col xs={ 24 } md={10} >
                                                        <FromInput value={ valuseLabel.birthDate ? changeFormatdate(valuseLabel.birthDate) : null} required={false} disabled={true} name={"code"} label="วันเกิด" mode={"text"} />
                                                    </Col>

                                                    <Col xs={ 24 } md={4} className="mb-3">
                                                        <FromInput value={ valuseLabel.age ? valuseLabel.age : 0} required={false} disabled={true} name={"code"} label="อายุ" mode={"text"} />
                                                    </Col>
                                                </>
                                    })
                                : <Col xs={24} md={24} className="mx-4" align={"center"}>
                                    <Text>ไม่พบข้อมูลรายการครอบครัว</Text>
                                </Col>
                            }

                            {/* <Col xs={24} md={24} align={"right"} className="mt-5">
                                <Button type="primary" className="mx-2 btn-white-red" htmlType="submit" onClick={this.cancel}>
                                    ยกเลิก
                                </Button>
                                <Button type="primary" className="ml-2 color-white" htmlType="submit" onClick={this.handleSubmit}>
                                    ทำเรื่องเบิก
                                </Button>
                            </Col> */}
                        </Row>
                    </Form>
                </div>
            </div>
		)
	}
}

FormHospital.defaultProps = {
	autoFocus: false
}

FormHospital.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool
}

const WrappedFormHospital = Form.create()(FormHospital)

export default withApollo(WrappedFormHospital)